import { render } from "./TicketTemplateBuilder.vue?vue&type=template&id=22b26778"
import script from "./js/ticketTemplateBuilder.js?vue&type=script&lang=js&external"
export * from "./js/ticketTemplateBuilder.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__